import { Button } from 'frosted-ui';
import { ArrowUpRightFromSquare16, LinkSlash16 } from '@frosted-ui/icons';
import BuyerNotice from './BuyerNotice';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import type { SellerInfo } from '../types';

/** What a buyer sees at a link that leads nowhere, naming the seller when known. */
export default function DeadLinkNotice({ seller }: { seller: SellerInfo | null }) {
  useDocumentTitle(seller?.sellerName || 'Link not found');
  return (
    <BuyerNotice
      eyebrow={seller?.sellerName}
      icon={<LinkSlash16 style={{ width: 24, height: 24 }} />}
      title="This link isn't working"
      body={
        seller
          ? `The offer may have ended, or the link was copied wrong. You can still find ${seller.sellerName} on Whop.`
          : 'The offer may have ended, or the link was copied wrong. Ask whoever shared it for a new one.'
      }
      actions={
        seller && (
          <Button asChild size="3" variant="solid" className="pl-tap" style={{ width: '100%' }}>
            <a href={seller.storeUrl}>
              Visit {seller.sellerName} on Whop
              <ArrowUpRightFromSquare16 />
            </a>
          </Button>
        )
      }
    />
  );
}
